<template>
  <div id="slate-int-custom-button">
  	<span class="internal" :class="{isValid: valid}" v-on:click="customButtonClick">
  	<slot>Default</slot>
  	</span>
  </div>
</template>

<script>
export default {
  name: 'customButton',
  props: ['valid'],
  methods: {
    customButtonClick () {
      this.$emit('customButtonClick')
    }
  }
}
</script>

<style scoped>
#slate-int-custom-button {
  text-align: center;
}
.internal {
  position: relative;
  display: inline-block;
  padding: 0.75em;
  background: rgba(85, 0, 51, 0.5);
  color: white;
  cursor: default;
}
.isValid .internal {
  background: rgba(85, 0, 51, 1);
  cursor: pointer;
}
.isValid .internal:active {
  top: 1px;
}
</style>



// WEBPACK FOOTER //
// CustomButton.vue?cbb4589e